import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { createUser } from "../../API/functions";


export const useCreateUser = ({onSuccess}) => {
 
  const { mutate } = useMutation({
    queryKey: ["userAdd"],
    mutationFn: (vars) => createUser(vars),

    onSuccess: () => {
      if (onSuccess) onSuccess(); 
  
    },
    onError: (error) => {
      toast.error(error.response.data.message);
    },
  });
  return { mutate };
};
export default useCreateUser;
